import { useMutation } from '@apollo/client'
import { RENOMEAR_ITEM } from '../data/renomear-item'
import * as z from 'zod'
import { useSnackbar } from '@tecsinapse/cortex-react'
import { RenomearItemMutationMutation } from '@/core/types/graphql'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { t } from '@lingui/core/macro'
import { RenomearDialogProps } from '../components'

export const useRenomearDialog = ({
  pastaAtual,
  close
}: Omit<RenomearDialogProps, 'open'>) => {
  const [renomearItemMutation] =
    useMutation<RenomearItemMutationMutation>(RENOMEAR_ITEM)

  const { snackbar } = useSnackbar()

  const form = useForm({
    values: { novoNome: pastaAtual?.nome ?? '' },
    resolver: zodResolver(
      z.object({
        novoNome: z.string({ error: t`O Novo Nome é obrigatório` })
      })
    )
  })

  const onSubmit = async values => {
    try {
      await renomearItemMutation({
        variables: {
          idItemBiblioteca: pastaAtual?.id,
          novoNome: values.novoNome
        }
      })

      snackbar.show('success', t`Item renomeado com sucesso!`)

      form.reset()
      close()
    } catch {
      snackbar.show('error', t`Erro ao renomear item`)
    }
  }

  const closeForm = () => {
    form.reset()
    close()
  }

  return {
    form,
    onSubmit,
    closeForm
  }
}
